<template>
  <CelusAlert type="success">
    <slot />
  </CelusAlert>
</template>

<script setup lang="ts">
import CelusAlert from "@/components/util/CelusAlert.vue";

defineOptions({
  name: "CelusSuccessAlert",
});
</script>
